import { MoreVertical } from "lucide-react"
import { TotalHeadCount } from "./StatCardIcons"

export const ChartMainCard = ({ children, heading = null,
    subHeading = null,
    Icon = null,
    count = null,
    iconColor = null,
    headerRight = null,
    moreOff = false, }) => {
    return (
        <>
            <div
                className={`
      bg-white/80 shadow-card rounded-[10px] 
        border border-[#e1e4ea] 
        py-7 gap-5 w-full h-full 
        flex flex-col justify-between
        [scrollbar-width:none]
        [&::-webkit-scrollbar]:hidden
        [&_*::-webkit-scrollbar]:hidden
        [&_*]:[scrollbar-width:none]
      `}
            >
                <div className="flex flex-col gap-5 overflow-hidden w-full h-full">
                    <div className="space-y-2.5 pb-2.5 border-b border-[rgba(82,88,102,0.20)] px-7">
                        <div className="flex items-center justify-between">
                            <h3 className="text-base font-bold text-[#0E121B] flex items-center gap-[10px] [&[fill]]:fill-current [&[stroke]]:stroke-current">
                                <div className={`${iconColor ? iconColor : "bg-theme-green-light text-theme-green"} px-2 py-1 rounded-md`}>
                                    {Icon ? Icon : <TotalHeadCount />}
                                </div>
                                {heading}
                            </h3>
                            <div className="flex items-center gap-3">
                                {headerRight ? headerRight : null}
                                {count ? <span className={`${iconColor ? iconColor : "bg-theme-green-light text-theme-green"} px-2 py-1 rounded-md`}>{count}</span>  : moreOff ? <button className="text-[#A4A7AE]"><MoreVertical className="w-5 h-5" /></button> : null}
                            </div>
                        </div>
                        {subHeading ? <p className="text-sm text-[#535862]">{subHeading}</p> : null}
                    </div>

                    {children}

                </div>

            </div>
        </>
    )
}